import React from "react";
import aboutImg from "../../../assets/images/tokenomics.png";
import sectionBg from "../../../assets/images/TokenomicsBg.png";
import sectionBgV from "../../../assets/images/TokenomicsBg-vertical.png";
import { Container, BannerBg, VideoBg } from "./styles";
import Video from "../../../videos/logo.webm";
import Flip from "../../Flip";

const Tokenomics = () => {
  return (
    <Container id="tokenomics" className="dc-section">
      <img src={sectionBg} alt="" className="dc-background-img desktop" width="1248px" loading="lazy"/>
      <img src={sectionBgV} alt="" className="dc-background-img mobile" loading="lazy" />
      <div className="container">
        <h2 className="dc-title dc-title-right">Tokenomics</h2>
        {/* <p className="dc-text dc-text-right">
          In the ever-evolving landscape of the digital era, a new phenomenon
          has taken the world by storm – the widespread and captivating meme
          known as Grok. From its humble beginnings as an internet inside joke
          to becoming a global cultural sensation, Grok's rise to fame has been
          nothing short of extraordinary. Now, with the world of
          cryptocurrencies gaining immense popularity and recognition.
        </p> */}
        <div className="home_btn">
          <ul className="dc-ul">
            <li className="dc-list">
              <div className="dc-list__icon">
                <span></span>
              </div>
              <p className="dc-text">Contract renounced</p>
            </li>
            <li className="dc-list">
              <div className="dc-list__icon">
                <span></span>
              </div>
              <p className="dc-text">0% buy / 0% sell</p>
            </li>
            <li className="dc-list">
              <div className="dc-list__icon">
                <span></span>
              </div>
              <p className="dc-text">Lp lock 360 days</p>
            </li>
          </ul>
        </div>
      </div>
      <img src={aboutImg} className="hero-text-img" alt="" loading="lazy" />
      {/* <Flip /> */}
      {/* <BannerBg>
                <VideoBg autoPlay loop muted src={Video} />
              </BannerBg> */}
      {/* <video style="width: 100%;" autoplay muted loop id="myVideo">
                <source src="assets/video/" type="video/webm"> 
              </video>  */}
    </Container>
  );
};

export default Tokenomics;
